<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectContent, type SelectContentProps, type SelectContentEmits, useForwardPropsEmits } from "reka-ui";

const props = withDefaults(defineProps<SelectContentProps>(), {});
const emits = defineEmits<SelectContentEmits>();
// Only the set props and the emits as handlers; typed as such (see HPixSelectArrow).
const forwarded = useForwardPropsEmits(props, emits) as ComputedRef<SelectContentProps>;
</script>

<template>
  <SelectContent v-bind="forwarded">
    <slot />
  </SelectContent>
</template>
